import { format, isValid, isWithinInterval, parseISO, parse, formatISO } from 'date-fns';
const dateRegex = /^(\d{2}|\d{4})-?(\d{1,2})-?(\d{1,2})$/;
export const normalize = (str, options)=>{
    const now = new Date();
    const yearLimit = Number.parseInt(format(now, 'yy'), 10); // T.ex. 15 för 2015
    const nowMillenium = now.getFullYear() - yearLimit; // Blir 2000
    const dateMatch = str.trim().match(dateRegex);
    if (!dateMatch) {
        return str.trim();
    }
    let year = parseInt(dateMatch[1], 10);
    if (dateMatch[1].length === 2) {
        year = year <= yearLimit ? year + nowMillenium : year + nowMillenium - 100;
    }
    const parsedDate = parse(`${year}-${dateMatch[2]}-${dateMatch[3]}`, 'yyyy-MM-dd', new Date());
    if (!isValid(parsedDate)) {
        return str;
    }
    const res = formatISO(parsedDate, {
        representation: 'date'
    });
    return options?.addZeroTime ? `${res} 00:00:00` : res;
};
/**
 * Kollar om date är mellan (inklusive extermerna) from och to. Till skillnad från date-fns:s isWithinInterval slängs inget
 * fel om inputen är ogitlig utan då returneras false.
 *
 * @param date { Date }
 * @param start { string }
 * @param end { string }
 */ export const isBetweenDates = (date, start, end)=>{
    const dateStart = parseISO(start || '');
    const dateEnd = parseISO(end || '');
    return isValid(dateStart) && isValid(dateEnd) && isWithinInterval(date, {
        start: dateStart,
        end: dateEnd
    });
};
